class CustomFlow extends HTMLElement {
  constructor() {
    super();

    this.object = {
      product: {
        variantId: 0,
        handle: 0,
        title: '',
        description: ''
      },
      sellingPlan: {
        id: 0,
        title: ''
      },
      accessory: {
        variantId: 0,
        title: ''
      },
      price: 0
    };

    this.step = 1;
    
    this.progressBar = this.querySelector('progress-bar');
    this.sidebar = this.querySelector('side-bar');
    this.submitButton = this.querySelector('[data-submit]');
    this.cartButton = this.querySelector('[data-cart]');
    this.backButton = this.querySelector('[data-back]');
    this.items = this.querySelectorAll('.custom-flow--item');
    this.itemsContainer = this.querySelector('.custom-flow--items-container');
    this.headings = this.dataset.headings.split(',');
    this.heading = this.querySelector('[data-heading]');
    this.description = this.querySelector('[data-description]');

    this.bindEvents();
  }
  
  bindEvents() {
    if (this.backButton) {
      this.backButton.addEventListener('click', e => {
        this.renderStep(this.step, this.step - 1);
      });
    }

    if (this.submitButton) {
      this.submitButton.addEventListener('click', e => {
        this.renderStep(this.step, this.step + 1);
      });
    }

    this.bindItemsEvents();
  }
  
  bindItemsEvents() {
    if (this.items.length) {
      for (const item of this.items) {
        item.addEventListener('change', e => {
          if (this.step == 3) {
            for (const item of this.items) {
              item.classList.remove('active');

              if (item != e.target.closest('.custom-flow--item')) {
                item.querySelector('.custom-flow--item-input input').checked = false;
              }
            }

            e.target.closest('.custom-flow--item').classList.toggle('active', e.target.checked);

            if ([...e.target.closest('.custom-flow--item').classList].includes('active')) {
              this.selectItem(this.step, e.target.closest('.custom-flow--item').dataset.data.split(','));
            } else {
              this.selectItem(this.step, null);
            }
          } else {
            for (const item of this.items) {
              item.classList.toggle('active', item == e.target.closest('.custom-flow--item'));
            }

            this.selectItem(this.step, e.target.closest('.custom-flow--item').dataset.data.split(','));
          }
        });
      }
    }
  }

  bindFreqencyItemsEvents() {
    if (this.frequencyItems.length) {
      for (const frequencyItem of this.frequencyItems) {
        frequencyItem.addEventListener('change', e => {
          for (const frequencyItem of this.frequencyItems) {
            frequencyItem.classList.toggle('active', frequencyItem == e.target.closest('.custom-flow--frequency-item'));
          }

          this.selectedFrequency = e.target.closest('.custom-flow--frequency-item').dataset.sellingPlanId;
  
          this.selectItem(this.step, e.target.closest('.custom-flow--frequency-item').dataset.data.split(','));

          // Clicks the subscription tab whenever a frequency item is directly clicked without clicking the parant tab first.
          this.querySelector('[data-type="subscribe"]').click();
        });
      }
    }
  }

  renderStep(fromStep, step) {
    this.submitButton.disabled = true;
    this.step = step;

    switch (step) {
      case 1:
        this.itemsContainer.innerHTML = this.firstStepHTML;

        this.renderCallback();
        
        break;
      case 2:
        if (fromStep == 1) {
          this.firstStepHTML = this.itemsContainer.innerHTML;
        }

        if (this.object.product.handle && this.object.product.variantId && this.object.product.variantId != 0) {
          this.getProductInfo(this.object.product.handle).then(data => {
            let sellingPlanGroups = '';

            for (const selling_plan_group of data.selling_plan_groups) {
              if (selling_plan_group.app_id == '5859381') {
                let sellingPlans = '';

                for (const selling_plan of selling_plan_group.selling_plans) {
                  sellingPlans += `
                    <div class="grid__item">
                      <label class="custom-flow--frequency-item text-body-x-small ${selling_plan.name.includes('2 weeks') ? 'most-popular' : ''}" role="button" data-selling-plan-id="${selling_plan.id}" data-data="${selling_plan.id}, $${(parseFloat(this.fullPrice.replace('$', '')) * parseFloat('0.' + (100 - selling_plan_group.selling_plans[0].price_adjustments[0].value))).toFixed(2)}, ${selling_plan.name}">
                        <div class="custom-flow--item-input visually-hidden">
                          <input type="radio" name="CustomFlow_Frequency" />
                        </div>
                        ${selling_plan.name}
                      </label>
                    </div>
                  `;

                  if (fromStep == 1) {
                    if (selling_plan.name.includes('2 weeks')) {
                      this.object.sellingPlan = {
                        id: selling_plan.id
                      }
                    }
                  }
                }

                sellingPlanGroups += `
                  <div class="grid__item">
                    <label class="custom-flow--item color-scheme-1" data-data="subscribe" data-type="subscribe" role="button">
                      <div class="custom-flow--item-content-wrapper">
                        <div class="custom-flow--item-input">
                          <input type="radio" name="CustomFlow_SubscriptionOption" class="visually-hidden" />
                        </div>
                        <div class="custom-flow--item-content">
                          <h3 class="text-body font-body-bold custom-flow--item-title">${selling_plan_group.name}</h3>
                          <div class="price"><span class="h5">$${(parseFloat(this.fullPrice.replace('$', '')) * parseFloat('0.' + (100 - selling_plan_group.selling_plans[0].price_adjustments[0].value))).toFixed(2)}</span><s>${this.fullPrice}</s></div>
                          <div class="grid grid--4-col-desktop custom-flow--grid-frequencies">
                            ${sellingPlans}
                          </div>
                          ${this.dataset.subscriptionDescription != '' ? `
                            <div class="custom-flow--item-description text-body-small">
                              ${this.dataset.subscriptionDescription}
                            </div>
                          `: ''}
                        </div>
                      </div>
                    </label>
                  </div>
                `;
              }
            }

            this.itemsContainer.innerHTML = `
              <div class="grid grid--1-col grid--2-col-desktop">
                ${sellingPlanGroups}
                <div class="grid__item">
                  <label class="custom-flow--item color-scheme-1" data-data="0, ${this.fullPrice}, One-Time Purchase" data-type="one-time">
                    <div class="custom-flow--item-content-wrapper">
                      <div class="custom-flow--item-input">
                        <input type="radio" name="CustomFlow_SubscriptionOption" class="visually-hidden" />
                      </div>
                      <div class="custom-flow--item-content">
                        <h3 class="text-body font-body-bold custom-flow--item-title">One-Time Purchase</h3>
                        <div class="h5 color-foreground">${this.fullPrice}</div>
                        ${this.dataset.oneTimeDescription != '' ? `
                          <div class="custom-flow--item-description text-body-small">
                            ${this.dataset.oneTimeDescription}
                          </div>
                        `: ''}
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            `;

            this.renderCallback();
          });
        }
        
        break;
      case 3:
        // Add current product to cart whilst skipping smart cart openning.
        Rebuy.SmartCart.skip_open = true;
        this.addToCart(this.object);

        if (this.object.product.handle && this.object.product.variantId && this.object.product.variantId != 0) {
          this.getAccessoriesInfo(this.object.product.handle).then(data => {
            let accessories = '';

            for (const accessory of data.accessories) {
              // Convert encoded HTML to textarea value for safe decoding.
              let benefits = document.createElement('textarea');
              benefits.innerHTML = accessory.benefits;

              accessories += `
                <div class="grid__item">
                  <label class="custom-flow--item custom-flow--item-accessory color-scheme-1" data-data="${accessory.id}, ${accessory.price}, ${accessory.name}" data-caption="${accessory.caption}" data-accessory-id="${accessory.id}">
                    <div class="custom-flow--item-content-wrapper">
                      <div class="custom-flow--item-input">
                        <input type="checkbox" name="CustomFlow_AccessoryOption" class="visually-hidden" />
                      </div>
                      <div class="custom-flow--item-content">
                        <h3 class="text-body font-body-bold custom-flow--item-title">${accessory.name}</h3>
                        <div class="text-body h5 font-body-bold">${accessory.price}</div>
                        <p class="text-body-x-small">${accessory.info}</p>
                        <div class="custom-flow--item-description text-body-small">${benefits.value}</div>
                      </div>
                    </div>
                    <img class="custom-flow--item-image" src="${accessory.image}" loading="lazy" />
                  </label>
                </div>
              `;
            }

            this.itemsContainer.innerHTML = `
              <div class="grid grid--2-col">
                ${accessories}
              </div>
            `;
            
            this.renderCallback();
          });
        }

        break;
      case 4:
        // Submit handler for proceed to checkout
        if (this.object.accessory && this.object.accessory.variantId != 0) {
          this.addAccessoryToCart(this.object).then(resp => {
            this.proceedToCheckout();
          });
        } else {
          this.proceedToCheckout();
        }

        break;
    }
  }
  
  renderCallback() {
    // If not on step 3, only enable the button if an item is pre-selected on rendering, otherwise the button will enable on selectItem anyway.
    if (this.step != 3) {
      this.submitButton.disabled = !this.querySelector('.custom-flow--item.active');
    } else {
      this.submitButton.disabled = false;
    }
  
    this.items = this.querySelectorAll('.custom-flow--item');
    this.frequencyItems = this.querySelectorAll('.custom-flow--frequency-item');

    this.bindItemsEvents();
    this.bindFreqencyItemsEvents();

    this.selectDefaults();

    this.updateContent();
    this.progressBar.update(this.step);

    // Hides the back button if on step 1.
    this.backButton.classList.toggle('hidden', this.step == 1);

    this.updateHeading();
    this.updateSubmitButton();
    this.toggleCartButton();

    if (!document.body.classList.contains('template-page-flow')) {
      this.scrollToTop();
    }
  }

  scrollToTop() {
    window.scrollTo({ top: this.parentNode.offsetTop, behavior: 'smooth' });
  }

  updateContent() {
    this.sidebar.update(this.object);

    if (this.step == 1) {
      if (this.object.product.description && this.object.product.description != '') {
        this.description.innerHTML = this.object.product.description;
      }
    }

    this.description.classList.toggle('hidden', this.step != 1);
  }

  toggleCartButton() {
    this.cartButton.classList.toggle('hidden', this.step != 3);
  }

  updateSubmitButton() {
    this.submitButton.innerHTML = this.step == 3 ? 'Proceed to Checkout' : 'Continue';
  }

  updateHeading() {
    // Updates the heading based on the step.
    this.heading.innerHTML = this.headings[this.step - 1];
  }

  proceedToCheckout() {
    window.location.href = '/checkout';
  }

  // Set values based on current object
  selectDefaults() {
    switch (this.step) {
      case 1:
        document.querySelector('.custom-flow--item.active').click();
        
        break;
      case 2:
        if (this.object.sellingPlan.title && this.object.sellingPlan.title.includes('One-Time')) {
          this.querySelector('.custom-flow--item[data-type="one-time"').click();
        } else {
          this.querySelector('.custom-flow--item[data-type="subscribe"').click();
        }

        if (this.object.sellingPlan && this.object.sellingPlan.id != 0) {
          this.querySelector(`[data-selling-plan-id="${this.object.sellingPlan.id}"]`).click();
        }
        
        break;
      case 3:
        this.selectedFrequency = null;

        if (this.object.accessory && this.object.accessory.variantId != 0) {
          this.querySelector(`[data-accessory-id="${this.object.accessory.variantId}"]`).click();
        }

        break;
    }
  }

  async getProductInfo(handle) {
    return await fetch(`/products/${handle.trim()}?view=subscription-info`).then(resp => resp.json())
  }

  async getAccessoriesInfo(handle) {
    return await fetch(`/products/${handle.trim()}?view=accessories-info`).then(resp => resp.json())
  }

  selectItem(step, data) {
    switch (step) {
      case 1:
        // Add product to object
        // Clear other props of object
        this.object = {};
        this.object.product = {
          variantId: data[0],
          handle: data[1],
          title: data[3],
          description: data[4]
        };
        this.object.price = data[2];
        this.fullPrice = data[2];

        klaviyoTracking({
          url: 'https://www.freshpatch.com/collections/choose-grass-pet-size?size=' + data[1],
          size: data[3]
        });
        
        break;
      case 2:
        // Add subscription option to object
        // Dont add if the user is selecting the subscribe card itself
        if (data[0] == 'subscribe') {
          if (this.selectedFrequency) {
            this.querySelector(`[data-selling-plan-id="${this.selectedFrequency}"]`).click();
          } else {
            if (this.object.sellingPlan.id == 0) {
              if (this.frequencyItems.length) {
                for (const frequencyItem of this.frequencyItems) {
                  if (frequencyItem.dataset.data.includes('2 weeks')) {
                    frequencyItem.click();
                  }
                }
              }
            }
          }
        } else {
          this.object.sellingPlan = {
            id: data[0],
            title: data[2]
          };
          this.object.price = data[1];
        }

        // Deselect frequencies if one-time option is set.
        if (this.object.sellingPlan.id == 0) {
          if (this.frequencyItems.length) {
            for (const frequencyItem of this.frequencyItems) {
              frequencyItem.querySelector('input').checked = false;
              frequencyItem.classList.remove('active');
            }
          }
        }
        
        break;
      case 3:
        if (data == null) {
          this.object.accessory = null;
        } else {
          // Add accessory to object
          this.object.accessory = {
            variantId: data[0],
            price: data[1],
            title: data[2]
          };
        }
        
        break;
    }

    this.submitButton.disabled = false;

    this.updateContent();
  }

  addToCart(object) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    let product = {
      id: object.product.variantId,
      quantity: 1
    };

    if (object.sellingPlan.id != 0) {
      product.selling_plan = object.sellingPlan.id;
    } else {
      delete product.selling_plan;
    }

    let data = {
      items: [
        product
      ]
    }; 

    config.body = JSON.stringify(data);

    fetch(routes.cart_add_url, config).then(resp => resp.json()).then(data => {});
  }

  async addAccessoryToCart(object) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    let product = {
      id: object.accessory.variantId,
      quantity: 1
    };

    let data = {
      items: [
        product
      ]
    }; 

    config.body = JSON.stringify(data);

    return await fetch(routes.cart_add_url, config).then(resp => resp.json());
  }
}

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    this.progress = this.querySelector('progress');
    this.text = this.querySelector('span');
  }

  update(step) { 
    if (this.progress && this.text) {
      this.progress.value = (100 / 3) * step;
      this.text.innerHTML = `${step} of 3`;
    }
  }
}

class Sidebar extends HTMLElement {
  constructor() {
    super();

    this.size = this.querySelector('[data-size]');
    this.frequency = this.querySelector('[data-frequency]');
    this.accessory = this.querySelector('[data-accessory]');
    this.total = this.querySelector('[data-total]');
    this.frequencyTotalWrapper = this.querySelector('[data-frequency-total-wrapper]');
    this.frequencyTotal = this.querySelector('[data-frequency-total]');
    this.labelFrequency = this.querySelector('[data-label-frequency]');
  }

  update(object) { 
    let isFrequencyPopulated = object.sellingPlan && object.sellingPlan.title;
    let isAccessoryPopulated = object.accessory && object.accessory.title;

    this.size.innerHTML = object.product.title;
    this.size.parentElement.classList.remove('not-populated');
    
    this.frequency.innerHTML = isFrequencyPopulated ? object.sellingPlan.title : '--';
    this.frequency.parentElement.classList.toggle('not-populated', !isFrequencyPopulated);

    if (object.accessory) {
      this.total.innerHTML = `$${parseFloat(parseFloat(object.price.replace('$', '')) + (object.accessory ? parseFloat(object.accessory.price.replace('$', '')) : 0)).toFixed(2)}`;
    } else {
      this.total.innerHTML = `$${parseFloat(object.price.replace('$', '')).toFixed(2)}`;
    }

    this.frequencyTotal.innerHTML = object.price;
    this.frequencyTotalWrapper.classList.toggle('hidden', object.sellingPlan == null || object.sellingPlan.id == 0);

    if (this.labelFrequency && object.sellingPlan != null && object.sellingPlan.id != 0 && object.sellingPlan.title) {
      this.labelFrequency.innerHTML = object.sellingPlan.title.toLowerCase();
    }

    this.accessory.innerHTML = isAccessoryPopulated ? object.accessory.title : 'Not added';
    this.accessory.parentElement.classList.toggle('not-populated', !isAccessoryPopulated);
  }
}

customElements.define('custom-flow', CustomFlow);
customElements.define('progress-bar', ProgressBar);
customElements.define('side-bar', Sidebar);

function klaviyoTracking(object) {
  var trackingObject = {
    'url': object.url,
    'size': ('size' in object) ? object.size : '',
    'frequency': ('frequency' in object) ? object.frequency : '',
    'accessory': ('accessory' in object) ? object.accessory : '',
  };
  if (typeof klaviyo != 'undefined') {
    klaviyo.push(['track', 'Custom Flow', trackingObject]);
  }
}